import httpManager from "@/app/shared/utils/httpManager";

/**
 * Get motives from an array of results
 *
 * @return {Promise<Array>} List of motives.
 */
export default async function (array) {
  const url = "/entities/motives/";
  let query = "?";
  if (array.length > 0) {
    array.forEach((id) => {
      query = query + "&result=" + id;
    });
  }
  const response = await httpManager.get(url + query);

  return response?.data;
}
